import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FaceHappy"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 9.21523 21.3938 6.54451 19.4246 4.57538C17.4555 2.60625 14.7848 1.5 12 1.5ZM12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21ZM6.75 10.1251C6.75 9.08953 7.58947 8.25006 8.625 8.25006C9.12351 8.24602 9.60277 8.44227 9.95528 8.79478C10.3078 9.14729 10.504 9.62655 10.5 10.1251C10.5 11.1606 9.66053 12.0001 8.625 12.0001C7.58947 12.0001 6.75 11.1606 6.75 10.1251ZM15.375 8.25006C14.3395 8.25006 13.5 9.08953 13.5 10.1251C13.5 11.1606 14.3395 12.0001 15.375 12.0001C16.4105 12.0001 17.25 11.1606 17.25 10.1251C17.254 9.62655 17.0578 9.14729 16.7053 8.79478C16.3528 8.44227 15.8735 8.24602 15.375 8.25006ZM12 17.9965C9.84323 17.9965 7.84691 16.8571 6.75 15.0001H17.25C16.1531 16.8571 14.1568 17.9965 12 17.9965Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FaceHappy.vue"]]);
